import React from 'react';
import { MapPin, Instagram } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden pt-20" id="home" data-id="element-15">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-16">
        <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80" alt="Market on 8th gathering space" className="w-full h-full object-cover object-center" data-id="element-17" />
        {/* Overlay */}
        <div className="absolute inset-0 bg-brand-dark/70 mix-blend-multiply" data-id="element-18"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/90 via-transparent to-transparent" data-id="element-19"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-left px-4 max-w-4xl mx-auto mt-[-5vh] md:ml-[8%]" data-id="element-20">
        <span className="inline-block font-display font-bold text-brand-gold tracking-widest uppercase text-sm md:text-base mb-4" data-id="element-21">
          National City · San Diego, CA · Est. 2021
        </span>
        <h1 className="font-display font-extrabold text-white text-6xl md:text-8xl lg:text-9xl leading-none mb-6 drop-shadow-lg uppercase" data-id="element-22">
          Market
          <br data-id="element-23" />
          <span className="text-brand-orange" data-id="element-24">on 8th</span>
        </h1>
        <p className="text-brand-cream text-lg md:text-xl max-w-2xl mb-10 font-medium leading-relaxed drop-shadow-md" data-id="element-25">
          A vibrant food hall in the heart of National City, bringing together
          flavors from Thailand, Japan, Mexico, Baja California, Michoacán,
          Sinaloa, and more.
        </p>

        <div className="flex flex-col sm:flex-row items-start gap-4" data-id="element-26">
          <a href="https://maps.app.goo.gl/2Q6LZT6rFPQtYsny5" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-brand-orange hover:bg-brand-coral text-white px-8 py-4 rounded-none font-bold transition-all transform hover:scale-105 shadow-lg w-full sm:w-auto uppercase tracking-wider text-sm" data-id="element-27">
            <MapPin size={20} strokeWidth={2.5} data-id="element-28" />
            Get Directions
          </a>
          <a href="https://www.instagram.com/marketon8thst/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-transparent border-2 border-white hover:bg-white hover:text-brand-dark text-white px-8 py-4 rounded-none font-bold transition-all w-full sm:w-auto uppercase tracking-wider text-sm" data-id="element-29">
            <Instagram size={20} strokeWidth={2} data-id="element-30" />
            Follow on Instagram
          </a>
        </div>
      </div>

      {/* Marquee */}
      <div className="absolute bottom-0 left-0 right-0 bg-brand-orange py-3 overflow-hidden z-20" data-id="element-31">
        <div className="marquee-container" data-id="element-32">
          {/* Repeat text to ensure seamless scrolling */}
          {[...Array(6)].map((_, i) => <span key={i} className="font-display text-sm font-extrabold uppercase tracking-[0.1em] text-white px-6 whitespace-nowrap" data-id="element-33">
              EAT · DRINK · MINGLE · 41 E. 8TH ST · NATIONAL CITY ·&nbsp;
            </span>)}
        </div>
      </div>
    </section>;
}